import axios from 'axios'
import {
  Notification,
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'
import {
  getToken,
  removeToken
} from '@/utilsCloud/auth'
import errorCode from '@/utilsCloud/errorCode'
import {
  tansParams
} from "@/utilsCloud/ruoyi";
import cache from '@/plugins/cache'
import Vue from 'vue';
// 是否显示重新登录
let isRelogin = true

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
// console.log('111', process.env)
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: '/prod-api', //打包发布接口前缀
  //  baseURL: '/', //本地开打接口前缀
  // 超时
  timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  const isEntpId = (config.headers || {}).isEntpId === true
  const isFile = (config.headers || {}).isFile === true
  if (isFile) {
    config.headers['Content-Type'] = 'multipart/form-data'
  }
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    if (isEntpId) {
      config.params.entpId = store.getters.enterpriseId;
    }
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    config.data = config.data || config.params;
    if (isEntpId) {
      config.data.entpId = store.getters.enterpriseId;
    }
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    // const sessionObj = cache.session.getJSON('sessionObj')
    const sessionObj = ''
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url; // 请求地址
      const s_data = sessionObj.data; // 请求数据
      const s_time = sessionObj.time; // 请求时间
      const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const message = '数据正在处理，请勿重复提交';
        // console.warn(`[${s_url}]: ` + message)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, error => {
  // console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res.data
    }
    if (code == 200) {
      res.data.success = true;
      if (res.data.rows && !res.data.data) {
        res.data.data = res.data.rows;
      }
    } else {
      res.data.success = false
    }
    let $message = res.data.msg || null;
    if (!res.data.message) {
      res.data.message = $message;
    }
    // if (msg != null) {
    //   if (msg.indexOf('内部服务器错误') > -1 || msg.indexOf('后端接口连接异常') > -1) {
    //     localStorage.clear()
    //     sessionStorage.clear()
    //     // Cookies.remove('Admin-Token');
    //     localStorage.setItem('tokenId', "");
    //     localStorage.setItem("enterpriseId", enterpriseId);
    //     store.dispatch('FedLogOut')
    //     Message({
    //       message: msg,
    //       type: 'error'
    //     })
    //     window.location.reload()
    //     return Promise.reject(new Error(msg))
    //   }
    // }
    if (code === 401 || (code == 500 && msg == '用户登录失败，请重新登录')) {
      if (res.data.msg == '令牌不能为空') {
        if(store.getters && store.getters.entpType != '2'){
          Vue.prototype.$loginBox();
        }
      } else {
        if (isRelogin) {
          isRelogin = false
          MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            isRelogin = true;
            if(store.getters && store.getters.entpType != '2'){
              Vue.prototype.$loginBox();
            }
            // store.dispatch('LogOut').then(() => {
            //   location.href = '/index';
            // })
            let enterpriseId = localStorage.getItem("enterpriseId");
            let courseId = localStorage.getItem("courseId");
            localStorage.clear()
            sessionStorage.clear()
            // Cookies.remove('Admin-Token');
            localStorage.setItem('tokenId', "");
            localStorage.setItem("enterpriseId", enterpriseId);
            localStorage.setItem("courseId", courseId);
            store.dispatch('FedLogOut')
            window.location.reload()
          }).catch(() => {
            let enterpriseId = localStorage.getItem("enterpriseId");
            let courseId = localStorage.getItem("courseId");
            removeToken();
            localStorage.clear()
            sessionStorage.clear()
            // Cookies.remove('Admin-Token');
            localStorage.setItem("enterpriseId", enterpriseId);
            localStorage.setItem("courseId", courseId);
            window.location.reload()
            isRelogin = true;
          });
        }

      }
      // }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    } else {
      isRelogin = true;
      return res.data
    }
  },
  error => {
    // console.log('err' + error)
    let {
      message
    } = error;
    if (message == "Network Error") {
      localStorage.clear()
      sessionStorage.clear()
      // Cookies.remove('Admin-Token');
      localStorage.setItem('tokenId', "");
      localStorage.setItem("enterpriseId", enterpriseId);
      store.dispatch('FedLogOut')
      Message({
        message: msg,
        type: 'error'
      })
      window.location.reload()
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)


export default service



// WEBPACK FOOTER //
// ./src/utilsCloud/request.js